var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7753 3.77339C11.4323 3.17498 9.93186 3.02673 8.49773 3.35076C7.06359 3.67478 5.77261 4.45372 4.81733 5.57139C3.86206 6.68906 3.29366 8.08559 3.19692 9.55269C3.10018 11.0198 3.48028 12.4789 4.28053 13.7123C5.08077 14.9457 6.25829 15.8874 7.63746 16.397C9.01664 16.9065 10.5236 16.9566 11.9335 16.5397C13.3435 16.1228 14.5809 15.2613 15.4612 14.0837C16.3416 12.9061 16.8177 11.4755 16.8185 10.0052V9.30867C16.8185 8.89027 17.1577 8.55109 17.5761 8.55109C17.9945 8.55109 18.3337 8.89027 18.3337 9.30867V10.0056C18.3326 11.8027 17.7507 13.5516 16.6748 14.9909C15.5988 16.4302 14.0864 17.4831 12.3631 17.9926C10.6398 18.5022 8.79804 18.441 7.11238 17.8182C5.42673 17.1955 3.98754 16.0445 3.00946 14.537C2.03138 13.0294 1.56682 11.2461 1.68506 9.453C1.80329 7.65987 2.498 5.95301 3.66556 4.58696C4.83312 3.22092 6.41098 2.26889 8.16381 1.87286C9.91665 1.47683 11.7505 1.65802 13.392 2.38941C13.7742 2.55969 13.9459 3.00755 13.7757 3.38973C13.6054 3.77191 13.1575 3.94367 12.7753 3.77339Z",
    fill: "#00AB86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1115 3.40908C18.4075 3.70478 18.4077 4.18445 18.112 4.48045L10.5363 12.0638C10.3942 12.206 10.2015 12.2859 10.0005 12.2859C9.79953 12.286 9.60676 12.2062 9.46464 12.064L7.19191 9.79132C6.89606 9.49547 6.89606 9.0158 7.19191 8.71995C7.48777 8.4241 7.96744 8.4241 8.26329 8.71995L10.0001 10.4567L17.0401 3.40961C17.3358 3.11361 17.8155 3.11337 18.1115 3.40908Z",
    fill: "#00AB86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.888ce9d9b54d43785bbcf2ee98c0b700.svg";
export { ForwardRef as ReactComponent };